import { injectGlobal } from 'styled-components'

export default (customCss) => {
  if (customCss) {
    return injectGlobal`
      .lp-button {
        background-color: ${customCss}!important;
      }
      a:not(.lp-button) {
          color: ${customCss}!important;
      }
    `;
  }

}
